<template>
  <div class="dialogItem">
    <el-checkbox-group class="cardName" size="medium" v-model="loadOption">
      <el-checkbox-button style="display:block;" v-for="(item,index) in loadOptions" :key="index" :label="item.cadCode">
        <div class="infoSource">
          <span><span class="nameSex">姓名:</span>{{item.name}}</span>
          <span><span class="nameSex">性别:</span>{{item.sex}}</span>
        </div>
        <div class="infoSource"><span class="nameSex">手机号:</span>{{item.mobile}}</div>
        <div class="infoSource"><span class="nameSex">卡号:</span>{{item.cadCode}}</div>
        <div class="infoSource"><span class="nameSex">信息来源:</span>{{item.informationSource}}</div>
      </el-checkbox-button>
    </el-checkbox-group>
    <div class="footer">
      <el-button type="primary" icon="el-icon-arrow-left" @click="lastPage">上一页</el-button>
      <el-button type="primary" @click="nextpage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      <el-button type="danger" @click="close">取 消</el-button>
      <el-button type="primary" @click="addInfo">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['loadOptions', 'formData', 'projectData'],
  data() {
    return {
      loadOption: [],
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.loadOption = []
    },
    // 确定选择信息
    addInfo() {
      if (this.loadOption && this.loadOption != '') {
        // 提取数组中相同的元素
        let mobileArr = this.loadOptions.filter(item => this.loadOption.some(ele => ele === item.cadCode));
        // 多个电话号码数据处理 /拼接赋值.join('').replaceAll(' ', '/')
        let arr = (mobileArr.map((value) => value.mobile)).map(function (item) {
          return item.replaceAll(' ', '/')
        })
        let mobileRes = Array.from(new Set(arr.map((value) => value.split('/')).flat().filter((num, index) => { return num !== '' }))).join('/')
        this.formData.mobile = mobileRes
        // 姓名处理
        let nameRes = Array.from(new Set(mobileArr.map((value) => value.name.split('/')).flat().filter((num, index) => { return num !== '' }))).join('/')
        this.formData.name = nameRes
        // console.log('mobileArr1');
        // console.log(Array.from(new Set(mobileArr.map((value) => value.name.split('/')).flat().filter((num, index) => { return num !== '' }))).join('/'));
        // 卡号处理
        let cardRes = mobileArr.map((value) => value.cadCode).filter((num, index) => { return num !== '' }).join('/')
        this.formData.cadCode = cardRes
        // 性别处理
        let sexRes = Array.from(new Set(mobileArr.map((value) => value.sex).filter((num, index) => { return num !== '' }))).join('/')
        this.formData.sex = sexRes
        // 客服处理
        let serviceRes = mobileArr.map((value) => value.empName).filter((num, index) => { return num !== '' }).join('/')
        this.formData.empName = serviceRes
        // 年龄处理
        let ageRes = mobileArr.map((value) => value.age).filter((num, index) => { return num !== '' }).join('/')
        this.formData.age = ageRes
        // }
        // 渠道
        let channelRes = mobileArr.map((value) => value.informationSource).filter((num, index) => { return num !== '' }).join('/')
        this.formData.informationSource = channelRes
        // 客户标签
        // let flagRes = mobileArr.map((value) => value.flag).filter((num, index) => { return num !== '' }).join('/')
        // this.formData.flag = flagRes
        // 调用父组件方法关闭弹窗
        this.$emit('close')
      }
      this.$emit('getData');
      if (this.projectData.length == 0) {
        this.$emit('getProject', 1, this.formData.mobile, this.formData.id);
      }
    },
    // 下一页
    nextpage() {
      let data = {
        mobile: this.formData.mobile,
        cadCode: this.formData.cadCode,
        name: this.formData.name,
        pageIndex: Lockr.get("selected") + 1,
      }
      api.requestQuiet("/skn/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          //当前页数+1
          this.loadOptions = res.data.mapList
          Lockr.set("selected", res.data.pageIndex)
        } else {
          _g.toast("warning", '已经是最后一页啦!');
          Lockr.set("selected", res.data.pageIndex)
        }
      }, (err) => {
        this.loading = false
      });
    },
    // 上一页
    lastPage() {
      if (Lockr.get("selected") < 2) {
        _g.toast("warning", '已经是第一页啦!');
      } else {
        let data = {
          mobile: this.formData.mobile,
          cadCode: this.formData.cadCode,
          name: this.formData.name,
          pageIndex: Lockr.get("selected") - 1,
        }
        api.requestQuiet("/skn/getClientInformation", data, (res) => {
          console.log(res)
          if (res.result == true) {
            this.loadOptions = res.data.mapList
            Lockr.set("selected", res.data.pageIndex)
          }
        }, (err) => {
          this.loading = false
        });
      }
    },
  }
}
</script>
<style scoped>
.dialogItem >>> .el-checkbox-button--medium .el-checkbox-button__inner {
  text-align: left;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
}
.dialogItem >>> .el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
}
.infoSource {
  margin-bottom: 10px;
}
.nameSex {
  font-weight: bold;
  margin-left: 16px;
}
.cardName {
  margin-bottom: 50px;
}
.footer {
  display: flex;
  justify-content: center;
}
</style>